import { useCompConfig } from "@/context/CompConfigContext";
import BangKeoKQV4 from "../BangKeoKQV4";
import { buildThemeStyle } from "./buildThemeStyle";

const KbvBangKeoKetQuaV4 = () => {
  const compConfig = useCompConfig();
  const { hasDataConfig } = compConfig;
  const themeStyle = buildThemeStyle(compConfig, hasDataConfig);

  return <BangKeoKQV4 type="ketqua" themeStyle={themeStyle} />;
};

export default KbvBangKeoKetQuaV4;
